<template>
  <v-container
    fluid
    class="d-flex flex-column justify-space-between align-center height-100"
  >
    <PrincipalHeader></PrincipalHeader>
    <div class="d-flex flex-column justify-center align-center">
      <div class="my-12 d-flex flex-wrap justify-center align-center">
        <v-card
          outlined
          max-width="25rem"
          width="100%"
          class="d-flex flex-column justify-center align-center pa-5 ma-5"
        >
          <v-img
            src="@/assets/img-empresa.svg"
            max-width="25rem"
            height="25rem"
            width="100%"
            contain
          ></v-img>
          <span class="text-center font-weight-bold size-22 dark--text">
            Temos planos exclusivos para gamers
          </span>
          <span class="text-center pt-4">
            Aqui voçê encontra a estabilidade que estava procurando para suas
            partidas on-line
          </span>
          <PrimaryButton
            class="ma-4"
            :label="'Ver Planos'"
            :to="'/planos/#gamer'"
          ></PrimaryButton>
        </v-card>
        <!-- Empresa -->
        <v-card
          outlined
          max-width="25rem"
          width="100%"
          class="d-flex flex-column justify-center align-center pa-5 ma-5"
        >
          <v-img
            src="@/assets/Rocket.svg"
            max-width="25rem"
            height="25rem"
            width="100%"
            contain
          ></v-img>
          <span class="text-center font-weight-bold size-22 dark--text">
            Empulsione seu <br />negócio
          </span>
          <span class="text-center pt-4">
            Cabeamento em fibra prezando a melhor estabilidade da sua internet
          </span>
          <PrimaryButton
            class="ma-4"
            :label="'Ver Planos'"
            :to="'/planos/#dedicado'"
          ></PrimaryButton>
        </v-card>
      </div>

      <!-- SpeedTest -->
      <div class="d-flex flex-column align-center pa-5 ma-5">
        <span class="text-center font-weight-bold size-32 dark--text">
          Teste sua Conexão
        </span>
        <span class="text-center font-weight-regular size-22 mb-5 dark--text">
          Saiba qual a velocidade da sua conexão com os servidores da VcomNet.
        </span>
        <a href="https://www.minhaconexao.com.br" class="img" target="_blank">
          <v-img
            max-width="25rem"
            height="25rem"
            width="100%"
            src="@/assets/SpeedTest.svg"
            contain
          ></v-img>
        </a>
      </div>

      <!-- Contato -->
      <v-card
        outlined
        max-width="31.25rem"
        width="100%"
        min-width="0"
        class="d-flex flex-column justify-center align-center pa-5 ma-5"
      >
        <span class="text-center font-weight-bold size-32 dark--text">
          Está enfrentando alguma Dúvida?
        </span>
        <span class="text-center font-weight-regular">
          Entre em contato conosco por meio de nosso formulário ou Whatsapp,
          nossa equipe responderá o mais rápido possivel.
        </span>
        <div class="d-flex align-center justify-center flex-wrap">
          <PrimaryButton
            class="ma-4"
            :label="'Contato'"
            :to="'/contato'"
          ></PrimaryButton>

          <v-btn
            elevation="0"
            width="10.625rem"
            height="2.4375rem"
            color="green1"
            class="ma-4 main-btn"
            target="_blank"
            :href="'https://api.whatsapp.com/send?phone=5581989021551'"
          >
            <v-icon color="neutral" left size="1.25rem">mdi-whatsapp</v-icon>
            <span class="neutral--text">Whatsapp</span>
          </v-btn>
        </div>
      </v-card>
    </div>
    <PrincipalFooter></PrincipalFooter>
  </v-container>
</template>

<script>
import PrimaryButton from '@/components/PrimaryButton.vue'
import PrincipalFooter from '@/components/PrincipalFooter.vue'
import PrincipalHeader from '@/components/PrincipalHeader.vue'

export default {
  name: 'HomeView',
  components: { PrincipalHeader, PrimaryButton, PrincipalFooter },
}
</script>
<style scoped lang="scss">
.gradient {
  background: linear-gradient(to top, $blue1 0%, rgb(45, 53, 66) 100%);
}
.img {
  width: 100%;
  max-width: 25rem;
}
</style>
